export enum PaymentFilesType {
  UNKNOWN = 'unknown',
  BILL = 'bill',
  INVOICE = 'invoice',
  INVOICE_ATTACHMENT = 'invoiceAttachment',
  RECEIVABLE_PAYMENT_ATTACHMENT = 'receivablePaymentAttachment'
}
